export function getWidgetNoteTextShadowStyle() {
  return {
    backgroundColor: "transparent",
    textShadowOffset: { width: 0, height: 0 },
    textShadowRadius: 3,
    textShadowColor: "black",
  };
}
